import React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';

import { CUSTOMER_DETAILS } from '../../steps';
import setProtectedDevice from '../../actions/set-protected-device';
import selectIssue from '../../actions/select-issue';
import Button from '../button';
import DetailsFetched from './details-fetched';

export default function({ onConfirm = () => {}, ...props }) {
  const dispatch = Redux.useDispatch();
  const {
    selectedDevices: { protectedDevice },
    pageText: {
      diagnosticButton,
      customerDetails: { diagnostic },
    },
  } = Redux.useSelector(state => state);

  React.useEffect(() => {
    dispatch(setProtectedDevice());
  }, [dispatch]);

  return (
    <Wrapper>
      <DetailsFetched {...props} ineligible={true} />
      <p>
        <b>&#10148; </b>
        {diagnostic.protectionPlan.p1}
        <a
          className="my-tmo-claim"
          href="https://www.mytmoclaim.com"
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          https://www.mytmoclaim.com
        </a>{' '}
        {diagnostic.protectionPlan.p2}
      </p>
      <p>
        <b>&#10148; </b>
        {diagnostic.appointment}
      </p>

      <Button
        className="confirm"
        disabled={!protectedDevice}
        name="Schedule Diagnostic (customer details modal)"
        onClick={() => {
          dispatch(
            selectIssue({
              name: 'diagnostic',
              displayName: diagnostic.displayName,
            })
          );
          onConfirm();
        }}
        step={CUSTOMER_DETAILS}
      >
        {diagnosticButton}
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  p {
    display: flex;
    color: red;
    text-align: left;
  }
  b {
    color: #3db0fb;
    padding-right: 10px;
  }
  .my-tmo-claim {
    color: #3db0fb;
    text-decoration: none;
    display: contents;

    &:hover {
      color: #000;
    }
  }
`;
